import links from "./links"

export type HeaderMobileLinksType = (typeof links)[keyof typeof links] & {
  subItems?: (typeof links)[keyof typeof links][]
  showBanner?: boolean
}

export const headerMobileLinks: HeaderMobileLinksType[] = [
  {
    ...links.MAIN_PAGE,
  },
  {
    ...links.FEATURES,
    subItems: [
      {
        ...links.SMART_TIME_TRACKING,
      },
      {
        ...links.TEAM_MANAGEMENT,
      },
      {
        ...links.CUSTOM_REPORTS,
      },
      {
        ...links.PTO_AND_LEAVE,
      },
      {
        ...links.WORK_ANOMALIES,
      },
      {
        ...links.ROLES_AND_PERMISSIONS,
      },
      {
        ...links.PAY_RATES,
      },
      {
        ...links.ATTENDANCE_AND_TIME_CARDS,
      },
      {
        ...links.CLIENTS_PROJECTS_AND_TASKS,
      },
      {
        ...links.TIME_AND_FINANCIAL_DASHBOARD,
      },
      {
        ...links.TIMESHEETS_AND_EXPENSES,
      },
    ],
  },
  {
    ...links.USE_CASES,
    subItems: [
      {
        ...links.FOR_AGENCIES,
      },
      {
        ...links.FOR_FREELANCERS,
      },
      {
        ...links.FOR_REMOTE_TEAMS,
      },
      {
        ...links.FOR_ENTERPRISES,
      },
      {
        ...links.FOR_SMALL_AND_MEDIUM_BUSINESSES,
      },
    ],
  },
  {
    ...links.PRICING,
  },
  {
    ...links.COMPANY,
    href: undefined,
    subItems: [
      {
        ...links.ABOUT_US,
      },
      {
        ...links.CONTACT_US,
      },
    ],
  },
  {
    ...links.BLOG,
  },
]
